import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MyService } from 'src/app/services/myservice';

@Component({
    selector: 'app-apiaccess',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './apiaccess.component.html',
    styleUrl: './apiaccess.component.scss'
})
export class ApiaccessComponent implements OnInit {

    errorMsg: string = '';
    apikeyval: string = '';
    currentTheme = localStorage.getItem('coreui-free-angular-admin-template-theme-default');
    previousTheme: string = '';
    navigateToDocumentation() {
        window.open('https://documentation.genailia.com/', '_blank');
    }
    isSecretKey: boolean = false;

    constructor(private cdr: ChangeDetectorRef, private myservice: MyService) { }

    ngOnInit(): void {
        this.myservice.setTitleAndMeta("Generate API Keys","Generate API Keys to use our product in a PaaS model. Access all our private APIs using the generated API Keys","Limits, REST API, api keys, private access, PaaS, SaaS, notifications,usage, account management, profile, login, signup, user manage, check usage","access-to-api-keys");
        this.myservice.getExistingToken().subscribe(
            (apikeyval) => {
                this.apikeyval = apikeyval.apiKey;
                this.isSecretKey = true;
            },
            (error) => {
                console.error('Error fetching token:', error);
                this.errorMsg = error;
            }
        );
    }

    genKey(): void {

        this.myservice.createNewToken().subscribe(
            (apikeyval) => {
                this.apikeyval = apikeyval.apiKey;
                this.isSecretKey = true;
                this.errorMsg = '';
            },
            (error) => {
                console.error('Error fetching token:', error);
                console.log('error msg' + Object.keys(error.error));
                this.errorMsg = error.error.message;
            }
        );
    }

    delKey(): void {
        this.myservice.deleteExistingToken().subscribe(
            (apikeyval) => {
                this.apikeyval = '';
                this.isSecretKey = false;
                this.errorMsg = '';

            },
            (error) => {
                console.error('Error fetching token:', error);
                this.errorMsg = error;
            }
        );
    }

    ngDoCheck(): void {
        const newTheme = localStorage.getItem('coreui-free-angular-admin-template-theme-default') || 'auto';
        if (this.previousTheme !== newTheme) {
            this.currentTheme = newTheme;
            this.currentTheme = this.currentTheme.replace(/"/g, '')
            this.previousTheme = newTheme;
            this.cdr.detectChanges();
        }
    }

    copyToClipboard() {
        const inputElement = document.getElementById('userId') as HTMLInputElement;
        if (inputElement) {
            navigator.clipboard.writeText(inputElement.value)
                .then(() => {
                    alert('Copied to clipboard!');
                })
                .catch(err => {
                    alert('Failed to copy!');
                });
        }
    }
}
